module.exports = __webpack_public_path__ + "static/img/netflix-footer-icon-en.c7690b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-footer-icon-en.png
// module id = 218
// module chunks = 1